import Router from './index'
import Vue from 'vue'


Router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }
  let token = localStorage.Token;
  if (token) {
    if (to.path === "/" || to.path === "/login" || to.path === "/register")
      next("/dashboard");
    else
      next();
  } else {
    if (to.path !== "/login" && to.path !== "/" && to.path !== "/register") {
      next({
        path: '/login',
        query: {
          nextUrl: to.fullPath
        },
      });
    }
    next();
  }
});

export default Router
